import $, {css} from 'jquery';

import cssClasses from '../helpers/cssClasses';

export default () => {
  function init() {
    setEventListeners();
  }

  function setEventListeners() {
    $('.charity__read-more').on('click', (ev) => {
      handleReadMore(ev);
    });
  }

  function handleReadMore(ev) {
    ev.preventDefault();
    const target = $('.charity__full-story');
    // $(target).toggle('slow');
    $(this).toggleClass(cssClasses.active);
    $(target).toggleClass(cssClasses.active);
    return false;
  }

  // Expose public interface.
  return Object.freeze({
    init,
  });
};
